<template>
  <div class="page-container">
    <a
      href="javascript:void(0)"
      style="
        color: #409eff;
        font-weight: bold;
        text-decoration: none;
        cursor: pointer;
        display: flex;
        justify-content: center;
      "
      @click="dialogVisible = true"
    >
      <svg-icon
        icon-class="icons8-camera-48"
        style="width: 2em !important; height: 1.5em !important"
      />
      AI 護照匯入
    </a>

    <el-dialog
      :visible.sync="dialogVisible"
      fullscreen
      :modal="false"
      :show-close="false"
      custom-class="fullscreen-passport-dialog"
      @opened="initCamera"
      @close="stopCamera"
    >
      <div class="passport-recognition-container">
        <header class="app-header">
          <div class="logo-area">
            <span class="logo-icon"
              ><img src="@/assets/images/logo3gtapp_new_20260710.png" style="width: 30px"
            /></span>
            <div class="logo-text-area">
              <div class="logo-text" style="font-size: 1rem">AI Passport Recognition System</div>
              <div class="logo-text" style="font-size: 1rem">{{ tourGroupNo }}</div>
            </div>
          </div>
        </header>

        <div class="main-content">
          <div class="camera-section">
            <video ref="video" autoplay playsinline class="video-stream"></video>
            <canvas ref="canvas" style="display: none"></canvas>
          </div>

          <div class="control-section">
            <button class="capture-btn" @click="takePhoto" :disabled="loading">
              <div class="inner-circle"></div>
            </button>
          </div>

          <div class="table-section">
            <el-table
              :data="tableData"
              border
              stripe
              height="100%"
              style="width: 100%"
              :header-cell-style="{ background: '#f5f7fa', color: '#606266', textAlign: 'center' }"
              :cell-style="{ textAlign: 'center' }"
              v-loading="loading"
            >
              <el-table-column prop="name" label="姓名" min-width="130">
                <template slot-scope="scope">
                  <el-input
                    size="small"
                    v-model="scope.row.name"
                    placeholder="請輸入姓名"
                    class="edit-input"
                  ></el-input>
                </template>
              </el-table-column>

              <el-table-column prop="birthday" label="生日" min-width="160">
                <template slot-scope="scope">
                  <el-date-picker
                    size="small"
                    v-model="scope.row.birthday"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="選擇生日"
                    style="width: 100%"
                  ></el-date-picker>
                </template>
              </el-table-column>

              <el-table-column prop="idNumber" label="身分證字號" min-width="160">
                <template slot-scope="scope">
                  <el-input
                    size="small"
                    v-model="scope.row.idNumber"
                    placeholder="請輸入身分證"
                    class="edit-input"
                  ></el-input>
                </template>
              </el-table-column>

              <el-table-column prop="passportNumber" label="護照號碼" min-width="160">
                <template slot-scope="scope">
                  <el-input
                    size="small"
                    v-model="scope.row.passportNumber"
                    placeholder="請輸入護照號碼"
                    class="edit-input"
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="80">
                <template slot-scope="scope">
                  <el-button
                    type="danger"
                    icon="el-icon-minus"
                    circle
                    size="mini"
                    @click="handleDelete(scope.$index)"
                  ></el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>

        <footer class="action-footer">
          <el-button
            type="danger"
            class="btn-import"
            @click="handleImport"
            :loading="loading"
            :disabled="!tableData || tableData.length <= 0"
          >
            匯入系統
          </el-button>
          <el-button type="info" class="btn-leave" @click="handleLeave"> 離開頁面 </el-button>
        </footer>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { ocrPassportToTraveler, setTravelers } from '@/api/travel'
import dayjs from 'dayjs'

export default {
  name: 'OcrImportTouristDialog',
  props: {
    travelID: {
      type: Number,
      required: true,
    },
    tourGroupNo: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      dialogVisible: false,
      videoStream: null,
      loading: false,
      tableData: [],
    }
  },
  beforeDestroy() {
    this.stopCamera()
  },
  watch: {
    async loading(newValue) {
      if (newValue) {
        try {
          await this.$store.dispatch('app/showAIProcessLoading', true)
          await this.$store.dispatch(
            'app/showAIProcessLoadingText',
            'AI解析護照中，請不要離開此畫面，感謝您的耐心等候。'
          )
        } catch (error) {
          console.error('Loading 初始化失敗:', error)
          await this.$store.dispatch('app/showAIProcessLoading', false)
        }
      } else {
        await this.$store.dispatch('app/showAIProcessLoading', false)
      }
    },
  },
  methods: {
    // 啟動相機 (在彈窗動畫完成後觸發，避免節點未渲染問題)
    async initCamera() {
      try {
        if (navigator.permissions && navigator.permissions.query) {
          const permissionStatus = await navigator.permissions.query({ name: 'camera' })

          if (permissionStatus.state === 'denied') {
            this.$message.error('相機權限已被拒絕，請開啟相機權限。')
            return
          }
        }

        const devices = await navigator.mediaDevices.enumerateDevices()
        const hasCamera = devices.some(device => device.kind === 'videoinput')
        if (!hasCamera) {
          this.$message.error('偵測不到相機裝置。')
          return
        }

        this.videoStream = await navigator.mediaDevices.getUserMedia({
          video: { facingMode: 'environment' },
        })

        if (this.$refs.video) {
          this.$refs.video.srcObject = this.videoStream
        }
      } catch (error) {
        console.error(error)
        this.$message.error('無法啟動相機，請檢查設備或瀏覽器權限。')
      }
    },
    // 關閉相機
    stopCamera() {
      if (this.videoStream) {
        this.videoStream.getTracks().forEach(track => track.stop())
        this.videoStream = null
      }
    },
    // 拍照
    async takePhoto() {
      if (navigator.permissions && navigator.permissions.query) {
        const permissionStatus = await navigator.permissions.query({ name: 'camera' })

        if (permissionStatus.state === 'prompt' || permissionStatus.state === 'denied') {
          await this.initCamera()
          return
        }
      } else {
        this.$message.error('不支援相機功能')
        return
      }

      const video = this.$refs.video
      const canvas = this.$refs.canvas
      if (!video || !canvas) return

      const context = canvas.getContext('2d')
      canvas.width = video.videoWidth
      canvas.height = video.videoHeight
      context.drawImage(video, 0, 0, canvas.width, canvas.height)

      const base64Image = canvas.toDataURL('image/jpeg')

      await this.uploadPassportImage(base64Image)
    },
    async uploadPassportImage(base64Data) {
      this.loading = true
      await ocrPassportToTraveler({
        file: {
          fileName: 'passport.jpg',
          base64: base64Data,
        },
      })
        .then(response => {
          if (response && response.success && response.data) {
            const newData = response.data
            this.tableData.unshift({
              name: newData.chineseName,
              birthday: newData.birthday,
              idNumber: newData.idNumber,
              passportNumber: newData.passportNumber,
            })
            this.$message.success('辨識成功！')
          }
        })
        .catch(error => {
          console.error('OCR 辨識錯誤:', error)
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleDelete(index) {
      this.tableData.splice(index, 1)
    },
    async handleImport() {
      if (this.tableData.length === 0) {
        this.$message.warning('目前沒有資料可供匯入。')
        return
      }
      if (confirm(`確定要將目前的資料匯入系統嗎？`)) {
        this.loading = true
        try {
          this.tableData.forEach(item => {
            if (item.birthDay) {
              // 定義允許的日期格式的正規表達式
              const dateFormatRegex = /^(?:\d{4}\/\d{2}\/\d{2}|\d{4}-\d{2}-\d{2})$/
              // 驗證日期格式
              if (!dateFormatRegex.test(item.birthDay)) {
                throw '生日日期格式不正確'
              }

              // 使用 dayjs 解析日期
              const isValidBirthday =
                dayjs(item.birthDay, 'YYYY-MM-DD', true).isValid() ||
                dayjs(item.birthDay, 'YYYY/MM/DD', true).isValid()

              // 驗證日期是否有效
              if (!isValidBirthday) {
                throw '生日日期不是有效日期'
              }
            }
            if (!item.name) {
              throw '旅客姓名為必填項目'
            }
          })

          var travelers = this.tableData.map((item, index) => ({
            travelersGroup: 1,
            name: item.name,
            birthDay: item.birthday,
            idCard: item.idNumber,
            passportNo: item.passportNumber,
            isMain: true,
            sort: index + 1,
            notice: {
              agencyRemind: '',
              leaderRemind: '',
            },
          }))

          await setTravelers({
            travelID: this.travelID,
            travelers,
          })
            .then(async response => {
              if (response && response.success) {
                await this.$emit('import-success')
                this.$message.success('資料匯入成功！')
                this.tableData = []
                this.loading = false
                this.dialogVisible = false
              }
            })
            .catch(error => {
              console.error('資料匯入錯誤:', error)
              this.$message.error(error)
            })
        } catch (e) {
          console.error('資料驗證失敗:', e)
          this.$message.error(e)
        } finally {
          this.loading = false
        }
      }
    },
    handleLeave() {
      if (confirm(`確定要離開頁面嗎？離開後未匯入的資料將會清空。`)) {
        this.tableData = []
        this.dialogVisible = false
      }
    },
  },
}
</script>

<style scoped>
/* 覆蓋 Element UI Dialog 的預設內邊距，使其完全滿版 */
::v-deep .fullscreen-passport-dialog {
  background-color: #ffffff !important;
}
::v-deep .fullscreen-passport-dialog .el-dialog__header {
  display: none !important; /* 隱藏預設標題列 */
}
::v-deep .fullscreen-passport-dialog .el-dialog__body {
  padding: 0 !important;
  height: 100vh;
  overflow: hidden;
}
::v-deep .el-message-box {
  display: block !important;
  width: 100% !important;
}

/* 獨立頁面主容器 */
.passport-recognition-container {
  display: flex;
  flex-direction: column;
  height: 100vh; /* 鎖定全螢幕高度 */
  background-color: #f8f9fa;
}

/* 頂部 Header */
.app-header {
  height: 60px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 24px;
  background-color: #ffffff;
  border-bottom: 1px solid #eef2f6;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.02);
  flex-shrink: 0;
}
.logo-area {
  display: flex;
  align-items: center;
  font-weight: bold;
  font-size: 18px;
  color: #1e293b;
}
.logo-icon {
  color: #4f46e5;
  margin-right: 8px;
}
.status-area {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #64748b;
}
.status-dot {
  width: 8px;
  height: 8px;
  background-color: #10b981;
  border-radius: 50%;
  margin-right: 8px;
  box-shadow: 0 0 8px #10b981;
}

/* 中間主內容滾動區 */
.main-content {
  flex: 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 0;
}

/* 相機區塊（寬度適應，在大螢幕上置中固定寬） */
.camera-section {
  width: 90%;
  height: 35vh;
  background-color: #000000;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
}
.video-stream {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* 拍照按鈕 */
.control-section {
  display: flex;
  justify-content: center;
  padding: 16px 0;
}
.capture-btn {
  width: 68px;
  height: 68px;
  border-radius: 50%;
  border: 4px solid #1e293b;
  background-color: transparent;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: all 0.2s ease;
}
.capture-btn:hover {
  transform: scale(1.05);
  border-color: #4f46e5;
}
.capture-btn:active {
  transform: scale(0.95);
}
.inner-circle {
  width: 48px;
  height: 48px;
  background-color: #1e293b;
  border-radius: 50%;
  transition: background-color 0.2s ease;
}
.capture-btn:hover .inner-circle {
  background-color: #4f46e5;
}

/* 表格區塊優化：寬度加寬、維持彈性高 */
.table-section {
  width: 90%;
  height: 30vh; /* 給予表格固定高度配合 height="100%" 讓內部出現滾動條 */
  margin-top: 12px;
  background: #ffffff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.03);
}

/* 底部按鈕區 */
.action-footer {
  height: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 24px;
  background-color: #ffffff;
  border-top: 1px solid #eef2f6;
  flex-shrink: 0;
}
.btn-import {
  background-color: #ef4444 !important;
  border-color: #ef4444 !important;
  color: #ffffff !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  padding: 12px 40px !important;
  border-radius: 6px !important;
}
.btn-import:hover {
  opacity: 0.9;
}
.btn-leave {
  background-color: #64748b !important;
  border-color: #64748b !important;
  color: #ffffff !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  padding: 12px 40px !important;
  border-radius: 6px !important;
}
.btn-leave:hover {
  opacity: 0.9;
}
.logo-text-area {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;

  @media (max-width: 400px) {
    flex-direction: column;
    justify-content: flex-start;
    gap: 0px;
  }
}
</style>
